import { render, staticRenderFns } from "./lang-switch.vue?vue&type=template&id=306b13e9&scoped=true&"
import script from "./lang-switch.vue?vue&type=script&lang=ts&"
export * from "./lang-switch.vue?vue&type=script&lang=ts&"
import style0 from "./lang-switch.vue?vue&type=style&index=0&id=306b13e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b13e9",
  null
  
)

export default component.exports